import { createFileRoute } from '@tanstack/react-router'
import KohBusPaymentProcess from '@/components/make-booking/payment/PaymentProcess'

export const Route = createFileRoute('/make-booking/$id/payment/process')({
  component: RouteComponent,
})

function RouteComponent() {
  return <KohBusPaymentProcess />
}
